import { SiloManagement } from 'views/site-settings/features/inventory-silo-management/types/silo-management.type';

export const SiloData: SiloManagement[] = [
  {
    id: '6e529e40-c6ab-4c08-a971-c5d7586e3607',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '7',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '2ac019ff-9dfc-4852-a151-44f7ba42b85b',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: 'silo 69',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: 'eba76558-ad23-41e7-aa98-859133310fa5',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '20',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '56bf5521-18b4-4e62-a8fc-c07855b24a07',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '6',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '11f1b92e-7cb5-4345-bcf9-20466c2e7d9c',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '8',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '91e77634-b913-468d-9194-e297988483a2',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: 'WAREHOUSE',
    capacity: 0,
    isExtraStorage: true,
    description: null,
    fleetName: null,
    fleetId: null,
    isEnabled: true,
  },

  {
    id: 'c8d38185-4fdf-4c5e-87fb-302f78d00981',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '1',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '39f8ff3e-bb4f-4c61-9119-264ddc6f05b7',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '2',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
  {
    id: '789ced40-a83a-4b1b-bfb7-9b38f4ac33fe',
    siteId: 'bfd08b43-686d-490c-ab19-fc9c0ffb77f8',
    name: '4',
    capacity: 65000,
    isExtraStorage: false,
    description: '',
    fleetName: 'Fleet 1',
    fleetId: '675',
    isEnabled: true,
  },
];
